module.exports = __webpack_public_path__ + "img/P1.89f913a8.jpg";